import { render, staticRenderFns } from "./InventorySide.vue?vue&type=template&id=510be5f4&scoped=true"
import script from "./InventorySide.vue?vue&type=script&lang=js"
export * from "./InventorySide.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=510be5f4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510be5f4",
  null
  
)

export default component.exports